// Get modal element
const modal = document.getElementById("promotion__modal");

// Get open modal button
const openModal = document.getElementById("promotion__modal--btn");

// Get close button
const closeBtn = document.getElementsByClassName("promotion__close")[0];

// Function to reset popup state
function resetPopup() {
    $('.popup_col_grid').show(); // Show main grid
    $('.Step-1').show(); // Show step 1
    $('.step-2--list').hide(); // Hide step 2
    $('.step-3--list').hide(); // Hide step 3
    $(`[data-subset]`).hide(); // Hide all subsets
    $(`[data-subinner]`).hide(); // Hide all sub-inner
}

// Listen for open click
openModal.onclick = function() {
    modal.style.display = "block";
    document.body.classList.add('promotion__popup--open');
}

// Listen for close click
closeBtn.onclick = function() {
    modal.style.display = "none";
    document.body.classList.remove('promotion__popup--open');
    resetPopup(); // Reset the popup when closed
}

// Listen for outside click
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
        document.body.classList.remove('promotion__popup--open');
        resetPopup(); // Reset the popup on outside click
    }
}

// Handle clicks on the inner grid
$('.popup_inner_grid').click(function() {
    var ids = $(this).attr('id').split('--')[1];
    var getindx = $(this).index();

    if ($(this).attr('data-relation') === 'parent') { // Step 1
        $('.popup_col_grid').hide();
        $('.Step-1').hide();
        $(`[data-subset='${ids}']`).show();
        $(`[data-subinner='${ids}']`).show();
    } else if ($(this).attr('data-relation') === 'child') { // Step 2
        $('.popup_col_grid').hide();
        $(`[data-subset='${ids}']`).find('.step__head').hide();
        $(`[data-subchild='${ids}']`).show();
        $('.step-3--list').hide();
        $(`[data-subchild='${ids}']`).find('.step-3--list').eq(getindx).show();
    }
});

// Handle back button clicks
$('.back-button').click(function(e) {
    e.preventDefault();
    var path = $(this).attr('data-path');
    var backid = $(this).attr('id');

    if (path === 'step-2') {
        $('.Step-1').show();
        $('.popup_col_grid').show();
        $(`[data-subset='${backid}']`).hide();
        $(`[data-subinner='${backid}']`).hide();
    } else if (path === 'step-3') {
        $('.popup_col_grid').show();
        $(`[data-subset='${backid}']`).find('.step__head').show();
        $(`[data-subchild='${backid}']`).hide();
    }
});
